import * as actions from "actions/reader";
import * as R from "ramda";

export default (state = {}, { type, payload }) => {
  switch (type) {
    case actions.FETCH_ALL_SUCCESS: {
      const readers = {};
      payload.data.forEach(reader => {
        readers[reader.id] = reader;
      });
      return readers;
    }

    case actions.DELETE_ONE_SUCCESS: {
      return R.dissoc(payload.id, state);
    }

    case actions.UPDATE_ONE_SUCCESS: {
      return R.assoc(payload.data.id, payload.data, state);
    }

    case actions.CREATE_ONE_SUCCESS: {
      return R.assoc(payload.data.id, payload.data, state);
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/reader/byId.js